import { Link } from "gatsby"
import BackgroundImage from "gatsby-background-image"
import { getImage } from "gatsby-plugin-image"
import { convertToBgImage } from "gbimage-bridge"
import React from "react"
import loadable from "@loadable/component"
import { Col, Container, Row } from "react-bootstrap"

class Cases extends React.Component {
  render() {
    const cases = this.props.allSanityCaseStudy.edges

    return (
      <>
        <div id="item-featured-container" className="mt-2">
          <div className="container">
            <div className="row">
              {!cases
                ? null
                : cases.map((studies, idx) => {
                    // const StudyBannerImg = getImage(
                    //   studies.node.bannerImage
                    //     ? studies.node.bannerImage.asset.gatsbyImageData
                    //     : ""
                    // )
                    // const StudyBannerBgImg = convertToBgImage(StudyBannerImg)

                    const StudyMainImg = getImage(
                      studies.node.mainImage
                        ? studies.node.mainImage.asset.gatsbyImageData
                        : ""
                    )
                    const StudyMainBgImg = convertToBgImage(StudyMainImg)

                    return (
                      <Col
                        md={6}
                        lg={4}
                        key={studies.node.id}
                        className="p-relative mb-4"
                      >
                        <div
                          className={`position-relative case-studies-wrapper`}
                          style={{
                            borderRadius: "5px",
                            height: "370px",
                            backgroundImage: `url("https://cdn.sanity.io/images/55lcecww/production/18b972bd27e8ed73c5e2e6e3062e23003eb68b77-800x800.jpg")`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                          }}
                        >
                          {/* <StaticImage
                                placeholder="none"
                                className="wave-img"
                                src="https://cdn.sanity.io/images/55lcecww/production/18b972bd27e8ed73c5e2e6e3062e23003eb68b77-800x800.jpg"
                                alt={studies.node.title}
                                layout="constrained"
                                style={{ height: "fit-content", zIndex: 0 }}
                                fetchpriority="low"
                              /> */}
                          <div
                            className="c-stud"
                            style={{ position: "relative", zIndex: 2 }}
                          >
                            <Link
                              to={`/case-study/${studies.node.slug.current}/`}
                            >
                              <p className="h5 text-white font-weight-bold">
                                {studies.node.title.length > 70
                                  ? `${studies.node.title.substring(0, 70)}...`
                                  : studies.node.title}
                              </p>
                            </Link>
                          </div>
                        </div>
                      </Col>
                    )
                  })}
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default Cases
